var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0466 3.25081C11.9571 4.52221 11.0354 5.50162 10.0304 5.50162C9.02539 5.50162 8.10223 4.52252 8.01425 3.25081C7.92261 1.92815 8.8198 1 10.0304 1C11.241 1 12.1382 1.95222 12.0466 3.25081Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0297 7.50171C8.03922 7.50171 6.12505 8.51349 5.64552 10.4839C5.58199 10.7446 5.74173 11.0025 6.00349 11.0025H14.0563C14.3181 11.0025 14.4769 10.7446 14.4143 10.4839C13.9347 8.48192 12.0206 7.50171 10.0297 7.50171Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.00189,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86389 3.81212C5.79614 4.82776 5.09026 5.62763 4.32937 5.62763C3.56847 5.62763 2.86143 4.82807 2.79484 3.81212C2.72564 2.75553 3.4127 2.00037 4.32937 2.00037C5.24603 2.00037 5.93309 2.77491 5.86389 3.81212Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03683 7.56375C5.51436 7.30522 4.93892 7.20581 4.32904 7.20581C2.82386 7.20581 1.37368 8.01391 1.01041 9.58792C0.962654 9.79612 1.08365 10.0021 1.28164 10.0021H4.53166",
    stroke: "#4B4B4B",
    strokeWidth: 1.00189,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1361 3.81078C14.2039 4.82642 14.9097 5.62629 15.6706 5.62629C16.4315 5.62629 17.1386 4.82673 17.2052 3.81078C17.2744 2.75418 16.5873 1.99902 15.6706 1.99902C14.754 1.99902 14.0669 2.77357 14.1361 3.81078Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9632 7.56241C14.4856 7.30388 15.0611 7.20447 15.671 7.20447C17.1761 7.20447 18.6263 8.01257 18.9896 9.58658C19.0373 9.79478 18.9164 10.0008 18.7184 10.0008H15.4683",
    stroke: "#4B4B4B",
    strokeWidth: 1.00189,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.4383f444df8f6578cff7bea3f0103584.svg";
export { ForwardRef as ReactComponent };